import React from 'react';
import { RESERVE_WHATSAPP_MESSAGE } from '../data/messages';
import { WhatsAppButton } from './WhatsAppButton';
export function UrgencySection() {
  return <section className="bg-white py-8 sm:py-14" data-id="element-337" data-mp="2sggccj4dd7v9">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-338" data-mp="36a7ntx1nv1tm">
        <div className="flex flex-col gap-4 rounded-xl border-l-4 border-accent-500 bg-steel-50 p-5 sm:p-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-339" data-mp="36bscx757hsk3">
          <div className="max-w-2xl" data-id="element-340" data-mp="3g6u2g43e8wn7">
            <h2 className="font-display text-2xl font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-341" data-mp="3g9yhjwiedcsn">
              ¿Tu colado ya tiene fecha? Aparta hoy tu precio
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-steel-600 sm:text-[15px]" data-id="element-342" data-mp="3p80lajtimjjm">
              Los precios de lista 2026 pueden cambiar con la materia prima y la disponibilidad se mueve rápido en
              temporada de obra. Confirma hoy y evita que tu losa se retrase por falta de material.
            </p>
          </div>
          <WhatsAppButton message={RESERVE_WHATSAPP_MESSAGE} label="Cotizar por WhatsApp" location="urgencia" intent="apartar" size="lg" className="shrink-0" data-id="element-343" data-mp="2sty0bj8x1el7" />
        </div>
      </div>
    </section>;
}